import { Pipe, PipeTransform } from '@angular/core';
import { ProductStylingViewModel } from '../../../models/shared/product-styling-view-model';
import { iif, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SectionColumnConfigCollectiveTerpeneKey } from '../../../models/enum/shared/section-column-config-collective-terpene-key';

@Pipe({
  name: 'isLowAmountTerpeneOrTAT',
  standalone: true
})
export class IsLowAmountTerpeneOrTATPipe implements PipeTransform {
  transform(
    productStylingViewModel: ProductStylingViewModel,
    terpenePascalCased: string,
    notApplicable: boolean = false
  ): Observable<boolean> {
    return iif(
      () => terpenePascalCased === SectionColumnConfigCollectiveTerpeneKey.TopTerpene || notApplicable,
      of(false),
      productStylingViewModel.rowViewModel$.pipe(
        map(sectionRowViewModel => sectionRowViewModel?.getTerpene(terpenePascalCased)?.indexOf('<') > -1)
      )
    );
  }
}
